export const CREATOR_UNKNOWN = 'unknown' as const;
export const DEFAULT_MEASUREMENT_UNIT = 'IN' as const;
